import moment from "moment";

export const calculateDayDiffFromToday = (futureDate) => {
  return moment.duration(futureDate.diff(moment().startOf("day"))).asDays();
};
